export function denormalizeZipCode(value: string) {
  return value.replace(/[-\s]/g, '');
}
